// Calculation backend (FastAPI). Local development runs it on :8000 - see docs/LOCAL_SETUP.md.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const API_KEY = process.env.REACT_APP_API_KEY || '';

// Helper function for API calls
const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  // Prepare headers with API key if available
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  // Add any additional headers from options
  if (options.headers) {
    Object.assign(headers, options.headers);
  }
  
  // Add API key if available
  if (API_KEY) {
    headers['X-API-Key'] = API_KEY;
  }
  
  try {
    const response = await fetch(url, {
      headers,
      ...options,
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error:', response.status, errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    
    return response.json();
  } catch (error) {
    console.error('API Call Error:', error);
    throw error;
  }
};

// Tax Calculator API
export const taxAPI = {
  getTaxRates: () => apiCall('/api/v1/tax/tax-rates'),
};

// Mortgage Calculator API
export const mortgageAPI = {
  calculateMortgage: (data: any) => apiCall('/api/v1/mortgage/calculate', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  calculateMonthlyPayment: (data: any) => apiCall('/api/v1/mortgage/calculate-monthly-payment', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  calculateAffordability: (params: any) => apiCall('/api/v1/mortgage/calculate-affordability', {
    method: 'POST',
    body: JSON.stringify(params),
  }),
  getAmortizationSchedule: (loanAmount: number, interestRate: number, loanTerm: number, limitMonths: number = 12) =>
    apiCall(`/api/v1/mortgage/amortization-schedule/${loanAmount}/${interestRate}/${loanTerm}?limit_months=${limitMonths}`),
};

// Investment Calculator API
export const investmentAPI = {
  calculateInvestment: (data: any) => apiCall('/api/v1/investment/calculate', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  calculateCashFlow: (params: any) => apiCall('/api/v1/investment/calculate-cash-flow', {
    method: 'POST',
    body: JSON.stringify(params),
  }),
  calculateROI: (params: any) => apiCall('/api/v1/investment/calculate-roi', {
    method: 'POST',
    body: JSON.stringify(params),
  }),
  calculateAppreciation: (params: any) => apiCall('/api/v1/investment/calculate-appreciation', {
    method: 'POST',
    body: JSON.stringify(params),
  }),
  calculateBreakEven: (params: any) => apiCall('/api/v1/investment/calculate-break-even', {
    method: 'POST',
    body: JSON.stringify(params),
  }),
  compareInvestments: (params: any) => apiCall('/api/v1/investment/compare-investments'),
};
